module.exports = __webpack_public_path__ + "static/james-park-117e661e29af1342761afd63b45bec99.jpg";